<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px;background-color: transparent;">
        <div>
          <h4 class="title">荣誉时间</h4>
          <el-date-picker
            v-model="honor_time"
            type="date"
            placeholder="选择时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div>
          <h4 class="title">荣誉内容</h4>
          <el-input v-model="content" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right;"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
        >保存</el-button>
        <el-button
          style="width: 106px; float: right;  margin-right: 15px;"
          size="small"
          @click="close()"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

var thisIndex;
var thisUserName;
var thisType;
var thisInfo = {};

export default {
  data() {
    return {
      changVisible: false,

      title: "",
      honor_time: "",
      content: "",
      clickLastTime: 0, //默认上一次点击时间为0
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;

      if (thisInfo == undefined) {
        thisInfo = {};
        thisInfo.id = 0;
      }
      thisInfo.delete_time = 0;
      switch (thisType) {
        case "ais_honor":
          if (isEmpty(this.honor_time) || isEmpty(this.content)) {
            this.$message.error("请完善信息");
            return;
          }
          var timestamp1 = parseInt(new Date().getTime());
          var timeStr = this.honor_time.replace(/-/g, "/");
          var timestamp2 = new Date(timeStr).getTime();
          thisInfo.honor_time = this.honor_time;
          thisInfo.content = this.content;
          break;
      }
      this.changVisible = false;
      this.$emit("toSave", thisIndex, thisType, thisInfo);
    },
    //页面初始化时加载的事件
    show(index, userName, type, info) {
      this.cleanInput();
      this.changVisible = true;
      thisIndex = index;
      thisUserName = userName;
      thisType = type;
      thisInfo = info;
      switch (thisType) {
        case "ais_honor":
          if (thisInfo === undefined) {
            this.title = "新增 " + thisUserName + " 荣誉信息";
          } else {
            this.title = "编辑 " + thisUserName + " 荣誉信息";
            this.editHonor(thisInfo);
          }
          break;
      }
    },
    // 清除输入框
    cleanInput() {
      this.honor_time = "";
      this.content = "";

      this.changVisible = false;
    },
    // 编辑荣誉信息
    editHonor(info) {
      this.honor_time = info.honor_time;
      this.content = info.content;
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addEditHonorDialog.vue